/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
// import ShutterStock from 'material/embeds/imageapi/imagepane/pane/images/shutterstock/shutterstock_container';
import { SelectField } from '@insticator/insticator-ui'; // iui-material
import Unsplash from 'material/embeds/imageapi/imagepane/pane/images/unsplash/unsplash_container';
import ImageTypes from 'material/embeds/imageapi/controller/imagetypes/imagetypes';
// import ImagePane from 'material/embeds/imageapi/imagepane/imagepane';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/images/image_toggle_styles';



/* ========== ~~~~~~~~~~ IMAGE TOGGLE ~~~~~~~~~~ ========== */
class ImageToggle extends Component {
	constructor(props) {
		super(props)
	};

	handleChange = (e) => this.props.imageTabSelect(e.target.value);

	render() {
		return (
			<div className={`image_toggle ${this.props.classes.image_toggle}`} >
				<div className={`controls ${this.props.classes.controls}`}>
					<div className={`innerControls`}>
						{/* wide view */}
						<ImageTypes selectAction={this.props.imageTabSelect} selected={this.props.imageTab} options={[
							{ name: 'unsplash', text: 'Unsplash' },
							// { name: 'shutterstock', text: 'Shutterstock' },
						]} />

						{/* thinner view */}
						<SelectField type={`select`} name={`imagetype`} defaultValue={this.props.imageTab} handleChange={this.handleChange} options={[
							{ name: 'unsplash', value: 'unsplash', text: 'Unsplash' },
							// { name: 'shutterstock', value: 'shutterstock', text: 'Shutterstock' },
						]} />
					</div>
				</div>
			</div>
		)
	};
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageToggle);
